import React from 'react';
import Select from '../../../components/ui/Select';

function CategoryFilter({ value, categories, onChange, disabled = false }) {
  const options = [
    { value: '', label: 'Todas as categorias' },
    ...categories.map((category) => ({
      value: category,
      label: category,
    })),
  ];

  return (
    <Select
      id="prompt-category-filter"
      label="Categoria"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      options={options}
      hint={disabled ? 'Carregando categorias...' : undefined}
    />
  );
}

export default CategoryFilter;
